import { render } from "./profile.vue?vue&type=template&id=f56c6dc0&scoped=true&ts=true"
import script from "./profile.vue?vue&type=script&lang=ts"
export * from "./profile.vue?vue&type=script&lang=ts"

import "./profile.vue?vue&type=style&index=0&id=f56c6dc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f56c6dc0"]])

export default __exports__